import { userInfoSync } from 'hub-http/userInfo';
let __gatesSet;
export const hasGate = gate => {
  if (!__gatesSet) {
    try {
      __gatesSet = new Set(userInfoSync({
        ignoreRedirect: true
      }).gates);
    } catch (e) {
      // Fall back to gated state for safety
      __gatesSet = new Set();
    }
  }
  return __gatesSet.has(gate);
};